module.exports = {"data":{"markdownRemark":{"frontmatter":{"title":"Donate"}}},"pathContext":{"id":"/opt/build/repo/src/pages/donate/index.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/donate.json
// module id = 1532
// module chunks = 109227225898571